import { inject, Injectable, PLATFORM_ID, TransferState, makeStateKey } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { GewerkDto } from '../models/gewerk.model';

const GEWERKE_KEY = makeStateKey<GewerkDto[]>('gewerke');

// SSR uses the Docker-internal URL; the browser goes through the dev proxy (/api/*)
const SSR_API_BASE = 'http://api:8080';

@Injectable({ providedIn: 'root' })
export class GewerkService {
  private readonly http = inject(HttpClient);
  private readonly transferState = inject(TransferState);
  private readonly platformId = inject(PLATFORM_ID);

  getAll(): Observable<GewerkDto[]> {
    // On the client: serve from TransferState if the server already fetched it
    if (isPlatformBrowser(this.platformId)) {
      if (this.transferState.hasKey(GEWERKE_KEY)) {
        const cached = this.transferState.get(GEWERKE_KEY, []);
        this.transferState.remove(GEWERKE_KEY);
        return of(cached);
      }
      return this.http.get<GewerkDto[]>('/api/gewerke');
    }

    // On the server: fetch directly from the internal API and store in TransferState
    return this.http.get<GewerkDto[]>(`${SSR_API_BASE}/api/gewerke`).pipe(
      tap((data) => this.transferState.set(GEWERKE_KEY, data)),
    );
  }
}
